export const TOGGLE_HOME = "TOGGLE_HOME";
export const TOGGLE_ABOUT = "TOGGLE_ABOUT";
export const TOGGLE_SCIENCE = "TOGGLE_SCIENCE";
export const SET_ACTIVE_MENUS = "SET_ACTIVE_MENUS";
export const RESET_SECTOR_MENU = "RESET_SECTOR_MENU";
export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const SET_HINDCAST_DATA = "SET_HINDCAST_DATA";
export const SET_BIOLOGICAL_RESULT = "SET_BIOLOGICAL_RESULT";
export const SET_MARINE_ENERGY_RESULT = "SET_MARINE_ENERGY_RESULT";
export const SET_BTM_DATAHUB_ACTIVE_PANEL = "SET_BTM_DATAHUB_ACTIVE_PANEL";
export const SET_BTM_DATAHUB_ACTIVE_MOMENT = "SET_BTM_DATAHUB_ACTIVE_MOMENT";
export const SET_BTM_BLUEGROWTH_ACTIVE_PANEL =
  "SET_BTM_BLUEGROWTH_ACTIVE_PANEL";
export const SET_BTM_TOOLS_ACTIVE_PANEL = "SET_BTM_TOOLS_ACTIVE_PANEL";
export const SET_BTM_TOOLS_ACTIVE_TOOL = "SET_BTM_TOOLS_ACTIVE_TOOL";
export const SET_ACTIVE_PRODUCT = "SET_ACTIVE_PRODUCT";
export const SET_ACTIVE_DEVICE = "SET_ACTIVE_DEVICE";
export const SET_BLUEGROWTH_OPERATIVITY_INPUTS =
  "SET_BLUEGROWTH_OPERATIVITY_INPUTS";
